import { IconArrowLeft } from "@tabler/icons-react";
import {useDB} from "../Services/useDB";
import {useEffect, useState} from "react";
import EventForm from "../Components/Event/EventForm";
import EventDelete from "../Components/Event/EventDelete";
import {useNavigate} from "react-router-dom";

export function Events() {

    const { getEvents, enableEvent } = useDB();
    const [events, setEvents] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchEvents = async () => {
            const eventsData = await getEvents();
            setEvents(eventsData);
        };

        fetchEvents();
    }, []);

    return (
        <div className="container-fluid mt-4">
            <div className="row row-cards">

                <div className="col-12">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
                            <div>
                                <h3 className="card-title mb-0">Events</h3>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <EventForm />
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-vcenter card-table table-hover">
                                <thead>
                                <tr>
                                    <th>Event Name</th>
                                    <th>Datum</th>
                                    <th>Event URL</th>
                                    <th>Rahmenbild</th>
                                    <th>Overlaybild</th>
                                </tr>
                                </thead>
                                <tbody>
                                { events.length > 0 && events.map((event, index) => (
                                    <tr className="pointer" key={index} >
                                        <td onClick={() => navigate(`/event/${event._id}`)}>{event.eventName}</td>
                                        <td onClick={() => navigate(`/event/${event._id}`)}>{event.datum}</td>
                                        <td onClick={() => navigate(`/event/${event._id}`)}>{event.url}</td>
                                        <td><img className="rahmenBild" src={`${process.env.REACT_APP_BACKEND_API_URL}/s3/file/${event.rahmenbild}`} /></td>
                                        <td><img className="rahmenBild" src={`${process.env.REACT_APP_BACKEND_API_URL}/s3/file/${event.overlaybild}`} /></td>
                                    </tr>
                                ))}


                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}